// extracted by mini-css-extract-plugin
export default {"markdownContainer":"MarkDownDisplay_markdownContainer__NkYsQ","light":"MarkDownDisplay_light__fcStA","dark":"MarkDownDisplay_dark__Ft-eO"};